import { render, staticRenderFns } from "./QuickReportForm.vue?vue&type=template&id=b27b6a2a&scoped=true"
import script from "./QuickReportForm.vue?vue&type=script&lang=js"
export * from "./QuickReportForm.vue?vue&type=script&lang=js"
import style0 from "./QuickReportForm.vue?vue&type=style&index=0&id=b27b6a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27b6a2a",
  null
  
)

export default component.exports